import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './ColorInput.module.css';
export function ColorInput({ value = '#FFFFFF', onChange, placeholder = 'FFFFFF', disabled = false, dataTestId, }) {
    const [internalColor, setInternalColor] = useState(value);
    const [textValue, setTextValue] = useState(value.replace('#', '').toUpperCase());
    const inputRef = useRef(null);
    const wrapperRef = useRef(null);
    useEffect(() => {
        setInternalColor(value);
        setTextValue(value.replace('#', '').toUpperCase());
    }, [value]);
    const handleTextChange = useCallback((e) => {
        if (disabled)
            return;
        const val = e.target.value.replace(/[^0-9A-Fa-f]/g, '').toUpperCase();
        if (val.length <= 6) {
            setTextValue(val);
            if (val.length === 6 || val.length === 3) {
                const newColor = '#' + val;
                setInternalColor(newColor);
                onChange?.(newColor);
            }
        }
    }, [disabled, onChange]);
    const handleColorPickerChange = useCallback((e) => {
        if (disabled)
            return;
        const newColor = e.target.value;
        setInternalColor(newColor);
        setTextValue(newColor.replace('#', '').toUpperCase());
        onChange?.(newColor);
    }, [disabled, onChange]);
    const handleColorSquareClick = useCallback(() => {
        if (disabled || !inputRef.current)
            return;
        inputRef.current.click();
    }, [disabled]);
    return (_jsxs("div", { ref: wrapperRef, className: `${styles.colorInputWrapper} ${disabled ? styles.disabled : ''}`, "data-testid": dataTestId, children: [_jsx("span", { className: styles.hash, "data-testid": dataTestId ? `${dataTestId}-hash` : undefined, children: "#" }), _jsx("input", { className: `${styles.colorText} ${disabled ? styles.disabled : ''}`, value: textValue, maxLength: 6, onChange: handleTextChange, placeholder: placeholder, disabled: disabled, "data-testid": dataTestId ? `${dataTestId}-text-input` : undefined }), _jsx("button", { type: 'button', className: styles.colorSquare, style: {
                    backgroundColor: internalColor,
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                }, onClick: handleColorSquareClick, disabled: disabled, "aria-label": `Color picker, current color: ${internalColor}`, "data-testid": dataTestId ? `${dataTestId}-color-square` : undefined }), _jsx("input", { ref: inputRef, type: 'color', value: internalColor, onChange: handleColorPickerChange, className: styles.hiddenColorInput, disabled: disabled, "data-testid": dataTestId ? `${dataTestId}-color-picker` : undefined })] }));
}
